<template>
	<div class="products-container">
		<div class="products" :class="{ 'products-inline': isInline }">
			<component
				v-for="product in products"
				:key="product.id"
				:class="productClass"
				:is="productComponent"
				@click="$emit('select', product)"
				:product="product"
				:theme="theme"
				:isActive="active.id == product.id"
			></component>
		</div>
	</div>
</template>

<script>
import { computed } from '@vue/reactivity'
import Product from '@/components/Product.vue'
import ProductInline from '@/components/ProductInline.vue'
import ProductLightened from '@/components/products/ProductLightened.vue'

const PRODUCT_COMPONENTS = ['Product', 'ProductInline', 'ProductLightened']
export default {
	components: { Product, ProductInline, ProductLightened },
	props: {
		productComponent: {
			type: String,
			default: 'Product',
			validator: (value) => {
				return PRODUCT_COMPONENTS.includes(value)
			}
		},
		products: {
			type: Array,
			required: true
		},
		active: {
			type: Object,
			required: true
		},
		theme: {
			type: String
		}
	},

	emits: ['select'],
	setup(props) {
		const isInline = computed(() => {
			return props.productComponent == 'ProductInline'
		})

		const productClass = computed(() => {
			return isInline.value ? `w-1/${props.products.length}` : ''
		})

		return { isInline, productClass }
	}
}
</script>

<style lang="scss" scoped>
.products-container {
	margin-top: 30px;

	&.compact {
		margin-top: 20px;
	}
}

.products {
	&-inline {
		display: flex;
		align-items: center;
		column-gap: 0.7rem;
	}
}
</style>
